'use client';
var classes = {"root":"m-b183c0a2"};

export { classes as default };
//# sourceMappingURL=Code.module.css.mjs.map
